const tipContainer = "_tipContainer_f56kr_1";
const styles = {
  tipContainer
};
export {
  styles as default,
  tipContainer
};
